import React from "react";

function UpArrow() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="23.335"
      height="24"
      viewBox="0 0 23.335 24"
    >
      <path
        id="Path_18535"
        data-name="Path 18535"
        d="M17.389,9.743V28h-3V9.743L6.343,17.789,4.222,15.667,15.889,4,27.556,15.667l-2.121,2.121Z"
        transform="translate(-4.222 -4)"
      />
    </svg>
  );
}

export default UpArrow;
